import React from "react";
import { GrantCommentAudienceType } from "../../../../../dtos/GrantCommentAudienceType";
import { Modules } from "../../../../../dtos/Modules";
import { DisplayType } from "../../../Types";
import GrantDetailComments from "../../../../grantDetails/GrantDetailComments";

type ISubTaskCommentsViewProps = {
    isVisible: boolean;
    isReadOnly: boolean;
    isDisabled: boolean;
    audienceOptions: Array<{ text: string; value: GrantCommentAudienceType }>;
    defaultAudience: GrantCommentAudienceType;
    audienceRoleNames: string[];
    displayType: DisplayType;
    notifyDefault: boolean;
    notifyVisible: boolean;
    module: Modules;
    grantId: string;
    stepId: string;
    stepName: string;
    onCommentAdded: () => void | Promise<void>;
};

export function SubTaskCommentsView({
    isVisible,
    isReadOnly,
    isDisabled,
    audienceOptions,
    defaultAudience,
    audienceRoleNames,
    displayType,
    notifyDefault,
    notifyVisible,
    module,
    grantId,
    stepId,
    stepName,
    onCommentAdded,
}: ISubTaskCommentsViewProps) {

    if (!isVisible) return null;

    return (
        <GrantDetailComments
            displayType={displayType}
            grantId={grantId}
            stepId={stepId}
            name={stepName}
            audienceOptions={audienceOptions}
            onCommentAdded={onCommentAdded}
            isReadOnly={isReadOnly}
            module={module}
            isDisabled={isDisabled}
            notifyDefault={notifyDefault}
            notifyVisible={notifyVisible}
            defaultAudience={defaultAudience}
            audienceRoleNames={audienceRoleNames}
        />
    );
}
